// External libraries
import React from 'react';

// Internal libraries
// @ts-expect-error TODO: @checkout/react-components
import { LoadingSpinner } from '@checkout/react-components';
// @ts-expect-error TODO:  lazyLoader
import { lazyLoader } from '@/lib';
import type { GenericObjectType } from '@/types';

export const LazyPasskeyEnrollmentPage = lazyLoader({
  loader: () => import('./PasskeyEnrollmentPage'),
  loading: () => <LoadingSpinner />,
  name: 'PasskeyEnrollmentPage',
  render(loaded: GenericObjectType, props: any) {
    const Component = loaded.PasskeyEnrollmentPage;
    return <Component {...props} />;
  },
});
